<!-- 重点部位压力，异常压力点 -->
<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
                
            </div>
        </div>
        <div class="m-panel-body">
          <div class="tabs" >
            <div class="tab" v-for="(item,index) in tabList" :key="item.key" :class="tabKey == item.key?'tab-active': ''"
              @click="handleChange(item,index)">
              <label class="tab-title">{{item.title}}</label>
            </div>
          </div>
          <div class="fixed">
            <!-- <div class="header-order">序号</div> -->
            <div class="header-item">{{ $t('管网名称') }}</div>
            <div class="header-item">{{ $t('实时压力') }}</div>
            <div class="header-item">{{ $t('实时流量') }}</div>
          </div>
          <div style="overflow: hidden;height: calc(100% - 65px);">
            <vue-seamless-scroll :data="list" class="seamless-warp" ref="seamlessScroll" :class-option="classOption" @ScrollEnd="ScrollEnd">
              <ul class="list-ul">
                <li class="list-row" v-for="(item, index) in list" :key="index">
                  <!-- <div class="list-order">
                    <div class="order">{{ index + 1 }}</div>
                  </div> -->
                  <div class="list-item">{{ item.name }}</div>
                  <div class="list-item">{{ item.ssyl }}</div>
                  <div class="list-item">{{ item.ssll }}</div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
    </div>
</template>
<script>
// import echarts from 'echarts/lib/echarts';
// import { getAction,postAction } from '@/api/manage'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  components: {
      vueSeamlessScroll
  },
    props: {
        titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('重点部位压力'),
            option: {},
            url:{
                //OnLineStatistical:"/wq/wQDataRecord/queryOnLineStatistical"
                OnLineStatistical:"/jeecg-charge/wq/meterDeviceBase/queryOnLineStatistical"
            },
            OnLineStatistical:[],
            intervalId: null,
            angle: 0,
            tabList: [
              {
                key: 0,
                title: this.$t('主管道')
              },
              {
                key: 1,
                title: this.$t('支管道')
              },
            ],
            tabKey: 0,
            list: [
              {name: '一号支管网',ssyl:'2.3MPa',ssll:'234m³/h'},
              {name: '二号支管网',ssyl:'2.4MPa',ssll:'333m³/h'},
              {name: '三号支管网',ssyl:'2.3MPa',ssll:'321m³/h'},
              {name: '四号支管网',ssyl:'2.4MPa',ssll:'235m³/h'},
              {name: '五号支管网',ssyl:'2.5MPa',ssll:'542m³/h'},
            ]
        }
    },
    computed: {
      goOn() {
        return this.errorNum < 5;
      },
      classOption() {
        return {
          step: 0.5, // 数值越大速度滚动越快
          limitMoveNum: this.list.length, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    mounted() {
    },
    methods: {
      ScrollEnd(){},
      handleChange(item) {
        this.tabKey = item.key
      },
      init() {
          this.getData();
      },
      getData() {
        
      },
    },
}
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    // position: absolute;
    // right: 0;
    margin-bottom: 5px;
  }
  
  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;
  
    cursor: pointer;
  }
  
  .tab-active {
    position: relative;
  }
  
  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;
  
  }
  
  .tab:last-child {
  
    margin-right: 0;
  }
  
  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }
  
  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }
  .fixed {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    background-color: #08306F;
    // margin: 10px 3px;
    // padding: 0 10px;
    color: #FFF;
    height: 30px;
  
    .header-item {
      width: 33.33%;
      text-align: center;
    }
  
    .header-order {
      width: 15%;
      text-align: center;
    }
  }
  
  .plant-bg {
    height: calc(100% - 40px);
    overflow: hidden;
    // background: url(../../../assets/img/plant5.png) center center no-repeat;
    // background-size: 100% 100%;
  }
  
  .list-ul {
    /* width: 100%;
      background: #f67;
      display: flex;
      justify-content: space-between; */
  }
  
  .list-row {
    // margin: 0 20px;
    color: #b6deff;
    display: flex;
    height: 33px;
    align-items: center;
    line-height: 35px;
    border: 1px solid #011a3a;
    // background: url(../../../assets/img/list-bg.png) center no-repeat;
    // background-size: 100% 100%;
  
    .order {
      // background: #0989ff;
      width: 48px;
      height: 18px;
      // border: 2px solid #0759a5;
      border-radius: 2px;
      text-align: center;
      line-height: 18px;
      color: #fff;
    }
  }
  
  .list-row .list-item {
    width: 33.33%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    color: #fff;
  }
  
  .list-order {
    width: 15%;
    display: flex;
    justify-content: center;
  }
  
  .fill-cicle {
    height: 10px;
    width: 10px;
    border-radius: 10px;
    box-shadow: 0 0 5px 5px rgba(255, 0, 0, 0.5);
  }
  
  ul {
    padding-inline-start: 0;
  }
  
  .seamless-warp {
    height: 100%;
  }
  
  .seamless-warp:hover {
    overflow-y: scroll;
  }
  
  .seamless-warp::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  .seamless-warp::-webkit-scrollbar-track {
    background: #0e0c4f;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-thumb {
    background: #292f88;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-corner {
    background: #0e0c4f;
  }
</style>